import React from 'react';
import Icon from '../../../components/AppIcon';

const TaskSummary = ({ tasks, familyMembers }) => {
  const getPersonStats = () => {
    return familyMembers?.map(member => {
      const memberTasks = tasks?.filter(task => task?.assignedTo === member?.name);
      const completedTasks = memberTasks?.filter(task => task?.status === 'completed')?.length;
      const inProgressTasks = memberTasks?.filter(task => task?.status === 'in-progress')?.length;
      const totalProgress = memberTasks?.reduce((sum, task) => sum + task?.progress, 0);
      const avgProgress = memberTasks?.length > 0 ? Math.round(totalProgress / memberTasks?.length) : 0;

      return {
        ...member,
        totalTasks: memberTasks?.length,
        completedTasks,
        inProgressTasks,
        avgProgress
      };
    });
  };

  const personStats = getPersonStats();
  const totalTasks = tasks?.length;
  const completedTasks = tasks?.filter(task => task?.status === 'completed')?.length;
  const inProgressTasks = tasks?.filter(task => task?.status === 'in-progress')?.length;
  const overallProgress = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="bar-chart-3" size={20} className="text-primary" />
        <h2 className="text-lg md:text-xl font-semibold text-foreground">Project Overview</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="bg-primary/10 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Total Tasks</span>
            <Icon name="list" size={18} className="text-primary" />
          </div>
          <p className="text-2xl md:text-3xl font-bold text-foreground">{totalTasks}</p>
        </div>

        <div className="bg-success/10 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Completed</span>
            <Icon name="check-circle-2" size={18} className="text-success" />
          </div>
          <p className="text-2xl md:text-3xl font-bold text-foreground">{completedTasks}</p>
        </div>

        <div className="bg-warning/10 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">In Progress</span>
            <Icon name="activity" size={18} className="text-warning" />
          </div>
          <p className="text-2xl md:text-3xl font-bold text-foreground">{inProgressTasks}</p>
        </div>

        <div className="bg-secondary/10 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Overall Progress</span>
            <Icon name="trending-up" size={18} className="text-secondary" />
          </div>
          <p className="text-2xl md:text-3xl font-bold text-foreground">{overallProgress}%</p>
        </div>
      </div>
      <div className="space-y-4">
        <h3 className="text-base md:text-lg font-semibold text-foreground mb-3">Member Distribution</h3>
        {personStats?.map((person) => (
          <div key={person?.id} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-xs font-semibold"
                  style={{ backgroundColor: person?.color }}
                >
                  {person?.initials}
                </div>
                <div>
                  <p className="text-sm md:text-base font-medium text-foreground">{person?.name}</p>
                  <p className="text-xs text-muted-foreground">{person?.role}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm md:text-base font-semibold text-foreground">{person?.totalTasks} tasks</p>
                <p className="text-xs text-muted-foreground">{person?.avgProgress}% avg progress</p>
              </div>
            </div>
            <div className="relative w-full h-2 bg-muted rounded-full overflow-hidden">
              <div
                className="absolute top-0 left-0 h-full rounded-full transition-smooth"
                style={{
                  width: `${person?.avgProgress}%`,
                  backgroundColor: person?.color
                }}
              />
            </div>
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>{person?.completedTasks} completed</span>
              <span>{person?.inProgressTasks} in progress</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskSummary;